<template>

  <div class="card">
    <div class="card-header">
      {{ $t('Share') }}
    </div>
    <div class="card-body">
      <label><strong>{{ $t('Social networks') }}</strong></label>
      <div>
        <SocialShare
          :url="job.career_url"
          :title="`Vaga: ${job.title} - ${job.account_id.name}`" />
      </div>

      <hr>

      <label><strong>{{ $t('Job URL') }}</strong></label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          :value="url"
          ref="input">
        <div
          class="input-group-append">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="copy">{{ $t('Copy') }}</button>
          <button
            type="button"
            class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div
            class="dropdown-menu dropdown-menu-right">
            <h6 class="dropdown-header">{{ $t('Track access') }}</h6>
            <div style="overflow: auto; max-height: 100px;">
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                v-for="(source, index) in sources"
                :key="index"
                @click="selectSource = source.name"
                :class="{active: selectSource === source.name}">
                {{ source.name }}
                </a>
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                @click="selectSource = null"
                :class="{active: selectSource === null}">
                Não rastrear
                </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import SocialShare from '@/components/Parts/SocialShare'

export default {
  name: 'JobAdvertise',
  components: {
    SocialShare
  },
  data () {
    return {
      sources: [],
      selectSource: null
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    url () {
      const parseUrl = new URL(this.job.career_url)
      if (this.selectSource) {
        parseUrl.searchParams.set('src', this.selectSource)
      } else {
        parseUrl.searchParams.delete('src')
      }
      return parseUrl.href
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getSources', {sort: 'name', limit: 2000})
      .then((result) => {
        this.sources = result.docs
      })
    },
    copy () {
      const textBox = this.$refs.input
      textBox.select()
      document.execCommand('copy')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertiseShare.vue